import React from 'react';
import { Text, TextType } from 'ui-components/components/text';
import { messages } from '../messages';
import styles from './style.module.css';

export const RecommendedIndicator = () => {
  return (
    <Text className={styles['recommended-indicator']} element='span' textType={TextType.Caption} value={messages.recommendedIndicator} />
  );
};
